export const PlayStates = {
    loaded: 'loaded',
    connecting: 'connecting',
    error: 'error',
    idle: 'idle',
    playing: 'playing',
    stopped: 'stopped',
    unplayable: 'unplayable',
};
export const Networks = {
    dfp: 'dfp',
    adswizz: 'adswizz',
    fallback: 'fallback',
};
export const LocalStorage = {
    PREROLL_LAST_PLAYED: 'PREROLL_LAST_PLAYED',
    AUDIENCES: 'LOTAME_LIGHTNING_AUDIENCES',
};
export const MediumTypes = {
    display: 'display',
    audio: 'audio',
    video: 'video',
};
export const SubscriptionStatus = {
    unknown: 'Unknown',
    none: 'None',
    active: 'Active',
    expired: 'Expired',
    temporarilyLocked: 'TemporarilyLocked',
    suspended: 'Suspended',
};
